import React from 'react';
import { Link } from 'react-router-dom';
import { Factory, ArrowLeft } from 'lucide-react';

const MIDCServicePage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <section className="hero hero-support relative overflow-hidden">
        <div className="container text-center relative z-10">
          <div className="flex justify-center mb-6">
            <div className="bg-primary-gradient rounded-2xl w-20 h-20 flex items-center justify-center shadow-lg">
              <Factory className="h-10 w-10 text-white" />
            </div>
          </div>
          <h1 className="hero-title">MIDC Service</h1>
          <p className="hero-subtitle">Maharashtra Industrial Development Corporation Services</p>
        </div>
      </section>
      <section className="section">
        <div className="container">
          <div className="mb-6">
            <Link 
              to="/services" 
              className="inline-flex items-center gap-2 px-4 py-2 bg-white hover:bg-gray-50 text-gray-800 hover:text-black border-2 border-primary-600 hover:border-primary-700 rounded-lg transition-all duration-300 group shadow-md hover:shadow-lg"
            >
              <ArrowLeft className="h-4 w-4 group-hover:-translate-x-1 transition-transform" />
              <span className="font-medium text-sm">Back to Services</span>
            </Link>
          </div>
          <div className="text-center">
            <h2 className="text-2xl font-bold mb-4">Service Coming Soon</h2>
            <p className="text-gray-600 mb-6">This service page is under development.</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MIDCServicePage;
